import React from 'react';
import { ArrowUp, ArrowDown, Minus } from 'lucide-react';

const ICON_BG = {
  emerald: 'bg-emerald-100 text-emerald-600',
  blue: 'bg-blue-100 text-blue-600',
  red: 'bg-red-100 text-red-600',
  amber: 'bg-amber-100 text-amber-600',
  teal: 'bg-teal-100 text-teal-600',
  slate: 'bg-slate-100 text-slate-600',
};

// trendGood: true => une hausse est positive (vert) ; false => une hausse est négative (rouge)
export const OpsKpiCard = ({ icon: Icon, label, value, tone = 'slate', trend, trendSuffix = 'vs hier', trendGood = true, testid }) => {
  const hasTrend = trend !== undefined && trend !== null;
  const up = hasTrend && trend > 0;
  const down = hasTrend && trend < 0;
  const flat = hasTrend && trend === 0;
  const positive = up ? trendGood : down ? !trendGood : false;
  const TrendIcon = up ? ArrowUp : down ? ArrowDown : Minus;
  const trendCls = flat ? 'text-gray-400' : positive ? 'text-emerald-600' : 'text-red-500';

  return (
    <div
      data-testid={testid}
      className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm transition-all hover:shadow-md hover:-translate-y-0.5"
    >
      <div className="flex items-start gap-3">
        <span className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${ICON_BG[tone] || ICON_BG.slate}`}>
          <Icon className="h-5 w-5" />
        </span>
        <div className="min-w-0">
          <p className="text-xs font-medium text-gray-500 truncate">{label}</p>
          <p className="mt-0.5 text-2xl font-bold tracking-tight text-gray-900 tabular-nums">{value}</p>
          {hasTrend ? (
            <p className={`mt-1 flex items-center gap-1 text-xs font-medium ${trendCls}`}>
              <TrendIcon className="h-3 w-3" />
              {flat ? 'Stable' : `${up ? '+' : ''}${trend} ${trendSuffix}`}
            </p>
          ) : (
            <p className="mt-1 text-xs text-gray-300">—</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default OpsKpiCard;
